module.exports = new __parcel__URL__("troops_super_swole.24ffd4e7.png").toString();